module.exports = __webpack_public_path__ + "img/07.8a2157ec.svg";